import type {
  CreatePaymentBundleRequest,
  PaymentBundleListResponse,
  PaymentBundleResponse,
} from "@przezmorze/api-types";
import { przezmorzeApi, throwMessageOnBadRequestStatus, throwMessageOnStatuses } from "../../../api/api";

export type { CreatePaymentBundleRequest as CreatePaymentBundleRequestBody, PaymentBundleResponse };

export async function createPaymentBundle(request: CreatePaymentBundleRequest, abortSignal?: AbortSignal) {
  try {
    const response = await przezmorzeApi.post<PaymentBundleResponse>("/cost-invoices/payment-bundles", request, {
      signal: abortSignal,
    });
    return response.data;
  } catch (error) {
    throwMessageOnBadRequestStatus(error);
  }
}

export async function deletePaymentBundle(bundleId: string, abortSignal?: AbortSignal) {
  try {
    await przezmorzeApi.delete<void>(`/cost-invoices/payment-bundles/${bundleId}`, {
      signal: abortSignal,
    });
  } catch (error) {
    throwMessageOnBadRequestStatus(error);
  }
}

export async function markPaymentBundleAsPaid(bundleId: string, abortSignal?: AbortSignal) {
  try {
    await przezmorzeApi.post<void>(`/cost-invoices/payment-bundles/${bundleId}/paid`, undefined, {
      signal: abortSignal,
    });
  } catch (error) {
    throwMessageOnStatuses(error, [404, 409]);
  }
}

export async function listPaymentBundles(showPaid: boolean, abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<PaymentBundleListResponse>("/cost-invoices/payment-bundles", {
    signal: abortSignal,
    params: {
      showPaid,
    },
  });
  return response.data.items;
}

export async function downloadPaymentBundleXml(bundleId: string, abortSignal?: AbortSignal): Promise<Blob> {
  const response = await przezmorzeApi.get<string>(`/cost-invoices/payment-bundles/${bundleId}`, {
    signal: abortSignal,
    responseType: "text",
    headers: {
      Accept: "application/xml",
    },
  });
  return new Blob([response.data], { type: "text/xml" });
}
